module.exports = __webpack_public_path__ + "img/midol_complete_caplets.7aba0001.jpg";